const aboutInfo = {
  title: {
    id: 'educationIntro',
  },
  description: {
    rows: [
      {
        id: 0,
        paragraphs: [
          {
            id: 0,
            // eslint-disable-next-line max-len
            text: 'The Fashion Education Network is a non-profit initiative by FashionUnited.',
          },
          {
            id: 1,
            // eslint-disable-next-line max-len
            text: 'As an online platform, the network connects the global fashion education market, where educators and schools can present themselves towards other institutes, students and the global fashion industry.',
          },
        ],
      },
      {
        id: 1,
        paragraphs: [
          {
            id: 0,
            // eslint-disable-next-line max-len
            text: 'The platform encourages fashion schools and educators to share news, knowledge and opportunities with each other. Providing information and resources contributing to the development of a talented and skilled future generation of fashion professionals.',
          },
        ],
      },
    ],
  },
  contact: {
    email: 'education@fashionunited.com',
    telephone: '+31 2 0 615 42 41',
  },
};

export default aboutInfo;
